import Reveal from "@/components/Reveal";

const HomeIntro = ({ content }) => {
  return (
    <section className="py-24 md:py-36 bg-transparent flex flex-col items-center text-center px-6">
      <div className="max-w-3xl mx-auto flex flex-col items-center">
        <Reveal>
          <div className="w-px h-16 bg-sm-gold mb-10 mx-auto" />
        </Reveal>
        
        <Reveal delay={0.1}>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-sm-text font-light leading-snug italic">
            {content?.title}
          </h2>
        </Reveal>

        <Reveal delay={0.2}>
          <p className="mt-10 text-sm md:text-base text-sm-muted leading-relaxed font-light max-w-2xl mx-auto tracking-widest uppercase">
            {content?.copy}
          </p>
        </Reveal>
        
        <Reveal delay={0.3}>
          <div className="w-px h-24 bg-sm-gold mt-16 mx-auto" />
        </Reveal>
      </div>
    </section>
  );
};

export default HomeIntro;
